import {CodeMirrorDiff} from '@github-ui/code-mirror/CodeMirrorDiff'
import {useId} from 'react'

import {useGuessCodeMirrorSettings} from '../../hooks/use-code-mirror-config'
import type {File} from './content-preview-types'

export function DiffView({left, right, view}: {left: File; right: File; view: 'split' | 'unified'}) {
  const leftLabelId = useId()
  const rightLabelId = useId()
  const unifiedLabelId = useId()
  const codeMirrorOptions = useGuessCodeMirrorSettings(left)

  return (
    <div>
      <span id={leftLabelId} className="sr-only">
        {left.name} original file contents
      </span>
      <span id={rightLabelId} className="sr-only">
        {right.name} modified file contents
      </span>
      <span id={unifiedLabelId} className="sr-only">
        {left.name} and {right.name} unified diff view
      </span>

      <CodeMirrorDiff
        fileName={left.name}
        left={left.value}
        leftLabelledBy={leftLabelId}
        right={right.value}
        rightLabelledBy={rightLabelId}
        spacing={codeMirrorOptions}
        unifiedLabelledBy={unifiedLabelId}
        view={view}
      />
    </div>
  )
}
